import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';
import 'cropperjs';
import CropHelper from './helpers/crop';
import ProfileUploadBaseController from './profile_upload_base_controller';

// Banner Photo Update Controller
export default class extends ProfileUploadBaseController {
  static targets = ['input', 'preview', 'cameraIcon', 'spinnerIcon'];

  connect() {
    this.setupFileInput();
    this.initCropHelper();
  }

  setupFileInput() {
    // Add event listener for file selection
    this.inputTarget.addEventListener(
      'change',
      this.handleFileSelect.bind(this)
    );
  }

  initCropHelper() {
    // Initialize the crop helper with banner configuration
    // Banner size: 512x144px (aspect ratio 16:4.5 or 3.55:1)
    this.cropHelper = new CropHelper({
      maxSize: 620, // Width
      aspectRatio: 620 / 256, // Exact aspect ratio as showing on the profile page
      initialCoverage: 1,
      previewElement: this.hasPreviewTarget
        ? this.previewTarget
        : document.getElementById('banner-image-preview'),
      onCropComplete: this.postToAPI.bind(this),
      onModalClose: this.resetFileInput.bind(this),
      modalId: 'banner-crop-modal',
      containerId: 'banner-cropper-container',
      closeButtonId: 'close-banner-crop-modal',
      doneButtonId: 'banner-crop-done-button',
    });
  }

  handleFileSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Check if file is an image
    if (!file.type.match('image.*')) {
      alert('Please select an image file');
      return;
    }

    // Create a FileReader to read the image
    const reader = new FileReader();
    reader.onload = (e) => {
      this.cropHelper.showCropModal(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  // Reset the file input so the same file can be selected again
  resetFileInput() {
    if (this.inputTarget) {
      this.inputTarget.value = '';
    }
  }

  postToAPI(croppedBlob, croppedDataUrl, originalBlob) {
    // Create a FormData object to send the image(s) to the server
    const formData = new FormData();

    // Always append the cropped banner image
    formData.append('user[banner_picture]', croppedBlob, 'banner_picture.png');

    // Conditionally append the original image for moderation
    if (originalBlob) {
      formData.append('moderation_image', originalBlob, 'moderation_image.png');
    }

    this.spinnerIconTarget.classList.remove('hidden');
    this.cameraIconTarget.classList.add('hidden');

    // Use Rails request.js to send the image to the server
    patch('/profile/update_banner', {
      body: formData,
      responseKind: 'json',
    })
      .then((response) => {
        if (response.ok) {
          return response.json;
        }
      })
      .then((data) => {
        // Success handling
      })
      .catch((error) => {
        console.error('Error updating banner picture:', error);
      });
  }

  disconnect() {
    // Clean up when controller is disconnected
    if (this.cropHelper) {
      this.cropHelper.destroy();
      this.cropHelper = null;
    }

    // Remove event listeners
    if (this.inputTarget) {
      this.inputTarget.removeEventListener('change', this.handleFileSelect);
    }
  }
}
